import { PlayerEvents } from '@4tn/core-audio-player-shared';
import NetworkManager from '@services/network-manager';
import EventDispatcher from '@utils/event-dispatcher';
import { type IPlayer } from '@players/types';

abstract class PlayerConnectionManager {
  public readonly networkManager: NetworkManager;

  constructor(protected readonly player: IPlayer) {
    this.networkManager = new NetworkManager();
  }

  public handleConnections(): void {
    this.networkManager.detachListeners();
    this.networkManager.listenConnectionChange();
    this.networkManager.setReconnectCallback(this.onNetworkReconnect.bind(this));
    this.networkManager.setDisconnectCallback(this.onNetworkDisconnect.bind(this));
  }

  public sendReconnectingEvent(): void {
    EventDispatcher.sendEvent(PlayerEvents.PLAYER_RECONNECTING);
  }

  public sendReconnectEvent(): void {
    EventDispatcher.sendEvent(PlayerEvents.PLAYER_RECONNECT, {
      name: PlayerEvents.PLAYER_RECONNECT,
      time: this.player.currentTime,
      volume: this.player.volumeLevel,
    });
  }

  public isOnline(): boolean {
    return this.networkManager.isOnline();
  }

  public onNetworkDisconnect(): void {}

  abstract onNetworkReconnect(): void;
}

export default PlayerConnectionManager;
